import { useState } from "react";

// Default date range: last 30 days to today
const getDefaultDateRange = () => {
  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);
  return {
    start: thirtyDaysAgo.toISOString().split("T")[0],
    end: today.toISOString().split("T")[0],
  };
};

const defaultDates = getDefaultDateRange();

/**
 * Hook to manage event filtering state (date range and event type)
 */
export function useEventFilters() {
  const [selectedEventType, setSelectedEventType] = useState<string>("all");
  const [startDate, setStartDate] = useState<string>(defaultDates.start);
  const [endDate, setEndDate] = useState<string>(defaultDates.end);

  // Convert dates to Unix timestamps
  const startTime = startDate
    ? Math.floor(new Date(startDate + "T00:00:00").getTime() / 1000)
    : undefined;
  const endTime = endDate
    ? Math.floor(new Date(endDate + "T23:59:59").getTime() / 1000)
    : undefined;

  const resetFilters = () => {
    setSelectedEventType("all");
    setStartDate(defaultDates.start);
    setEndDate(defaultDates.end);
  };

  return {
    selectedEventType,
    setSelectedEventType,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    startTime,
    endTime,
    resetFilters,
  } as const;
}
